export default "__VITE_PUBLIC_ASSET__30119463__"